export const GENERAL_LINK =
  "https://page.ma.scrmtech.com/landing-page/index?pf_uid=19697_1864&id=4396"

export const PRODUCT_LINK =
  "https://page.ma.scrmtech.com/landing-page/index?id=4397&pf_uid=19697_1864"

export const PARTNER_LINK =
  "https://page.ma.scrmtech.com/landing-page/index?pf_uid=19697_1864&id=4421&channel=9034"

export const ACTIVITY_LINK =
  "https://app.ma.scrmtech.com/meetings/MeetingPc/index?pf_uid=19697_1864&pf_type=3&category_id="

export const DOWNLOAD_LINK =
  "https://app.ma.scrmtech.com/resources/ResourcePc/resourcePcInfo?pf_uid=19697_1864&pf_type=3&id=21153"

export const LECTURER_PERSONAL =
  "https://app.ma.scrmtech.com/survey/index/index?suveryid=10923&pf_uid=19697_1864&pf_type=3&wx_id=1864"

export const LECTURER_INSTITUTIONS =
  "https://page.ma.scrmtech.com/landing-page/index?pf_uid=19697_1864&id=4514&channel=9034"

export const LECTURER_PERSONAL_APPLY =
  "https://asktug.com/t/topic/665469"
